import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type {
    Delivery,
    DeliveryVo,
    DeliveryForm,
    EvidenceMaterialInfo,
    DeliverySelectorParams,
    DeliveryPagingParams
} from "@zhihaoscm/entity";
import { type Page } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";

export class DeliveryService extends BaseService<unknown, Delivery, unknown, unknown> {
    /** 分页查询 */
    public async getPaging(params: DeliveryPagingParams): Promise<Page<DeliveryVo>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    /** 新增 */
    public async addDelivery(params: DeliveryForm): Promise<unknown> {
        const { data } = await this.service.post(`${this.path}`, params);
        return data;
    }

    /** 修改 */
    public async updateDelivery(id: string, params: DeliveryForm): Promise<unknown> {
        const { data } = await this.service.put(`${this.path}/${id}`, params);
        return data;
    }

    /** 修改佐证材料 */
    @confirmable("是否保存")
    public async updateFile(id: string, params: EvidenceMaterialInfo): Promise<unknown> {
        const { data } = await this.service.put(`${this.path}/update/evidence-material-info/${id}`, params);
        return data;
    }

    /** 删除 */
    public async deleteDelivery(id: string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /** 取消提货 */
    public async cancelDelivery(id: string) {
        const { data } = await this.service.put(`${this.path}/cancel/${id}`);
        return data;
    }

    /** 发起提货 */
    public async initiateDelivery(id: string) {
        const { data } = await this.service.put(`${this.path}/initiate/${id}`);
        return data;
    }

    /** 下拉 */
    public async getSelector(params: DeliverySelectorParams): Promise<DeliveryVo[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }

    /** 获取详情 */
    public async getDeliveryVo(id: string): Promise<DeliveryVo> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }

    /**
     * 详情快照------用于补录订单审核
     */
    public async getSnapshotVo(id: string): Promise<DeliveryVo> {
        const { data } = await this.service.get(`delivery-snapshot/vo/${id}`);
        return data;
    }
}

export const deliveryService = new DeliveryService("/admin/delivery", request.service);
